import React, { useState, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import {MapContainer, TileLayer, Marker, Popup, ZoomControl, Polyline, FeatureGroup, Polygon} from 'react-leaflet'
import 'leaflet/dist/leaflet.css'; // CSS di Leaflet
import './lib/leafletTileSeamPatch';
import 'leaflet-draw/dist/leaflet.draw.css'; // CSS di Leaflet Draw
import FlyObject from "./comp/FlyObject";
import FlyObjectDrone from './comp/FlyObjectDrone';
import FlyObjectBarca from './comp/FlyObjectBarca';
import InfoBox from "./comp/InfoBox";
import directionFunction from './lib/directionFunction';
import {
    cleanupFollowForClosedInfoboxes,
    getActiveFollowAlias,
    getOpenInfoboxAliases,
} from './lib/followState';
import ControlPanel from "./comp/ControlPanel";
import AuthController from './comp/AuthController';
import { createStreamingConfigFromProps, normalizeStreamingConfig } from './lib/streamingConfig';
import { createQcenterApiClient, ensureQcenterCsrfCookie } from './lib/qcenterApiClient';
import { startSessionPresence } from './lib/sessionPresence';
import { startLiveStreamCookieRefresh } from './lib/liveStreamAuth';
import { getSessionEpoch, isSessionActive, subscribeAccountChange, subscribeSessionActive } from './lib/sessionActivity';
import { HEARTBEAT_INTERVAL_MS } from './lib/deviceOnlineTiming';
import { LayerGroup, LayersControl } from "react-leaflet";
import ControlPanelResponsive from './comp/ControlPanelResponsive';
import AuthControllerWindy from './comp/AuthControllerWindy';
import ControlPanelWindy from './comp/ControlPanelWindy';
import InfoBoxWindy from './comp/InfoBoxWindy';
import InfoBoxResponsiveIos from './comp/InfoBoxResponsiveIos';
import InfoBoxResponsiveNoIos from './comp/InfoBoxResponsiveNoIos';
import UserObject from './comp/UserObject';
import Map3DComponent from './comp/Map3DComponent';
import { createPictureInPictureSession, exitPictureInPictureIfActive } from './lib/pictureInPictureSession';
import useDeviceOnlineStatus from './hooks/useDeviceOnlineStatus';
import { normalizeStartIndex } from './lib/infoboxScroll';
import { isUserDisabled, redirectDisabledUser } from './lib/userAccess';
import { hydrateHistoryPayload } from './lib/packetFields';
import { detectClientPlatform } from './lib/clientPlatform';
import { useMapGestureShield } from './lib/useMapGestureShield';
import { useTapBindings } from './lib/useTapBindings';


function App(props) {

    const { isMobile: isMob, isIos: isIOS } = detectClientPlatform();
    const { bindTap } = useTapBindings();
    const shieldControlPanel = useMapGestureShield(true);
    const shieldInfoPanels = useMapGestureShield(true);
    const shieldMobileControlPanel = useMapGestureShield(false);
    const shieldMobileInfo = useMapGestureShield(false);
    const shieldMobileInfoIos = useMapGestureShield(false);

    const [heading3D , setHeading] = useState(0);

    const [startIndex, setStartIndex] = useState(0);

    const _logga = (...any) => {
        // console.log("[htk][app]", ...any);
    }

    const flyZoomOptions = {
        animate: true, duration: 0.5
    }

    const [buttonStates, setButtonStates] = useState({});

    const [mappaWindy, setMappaWindy] = useState(null);

    const queryParams = new URLSearchParams(window.location.search)
    const codeStart = queryParams.get("code")
    _logga("codeStart", codeStart)
    const [startPosition, setStartPosition] = useState( props.startPosition);
    const [listSns, setListSns] = useState(props.sns);
    const [snsLive, setSnsLive] = useState([]);
    const snsLiveRef = useRef(snsLive);
    snsLiveRef.current = snsLive;
    const [serialsAttivi, setSerialsAttivi] = useState([]);
    const [FlyObjects, setFlyObjects] = useState([]);
    const [zoomLevelBase, setZoomLevelBase] = useState(7);
    const [snsJson, setSnsJson] = useState(props.snsJson);
    const [timePolling, setTimePolling] = useState(props.timePolling);
    const [code, setCode] = useState("1234");
    const [dataCode, setDaCode] = useState(null);
    const [userTipo, setUserTipo] = useState(0);
    const [isUserAccessResolved, setIsUserAccessResolved] = useState(props.accessMode);
    const [sessionActive, setSessionActiveState] = useState(false);
    const [accountEpoch, setAccountEpoch] = useState(0);
    const streamingConfigStartedRef = useRef(!props.loadStreamingFromApi);
    const [streamingConfig, setStreamingConfig] = useState(() => createStreamingConfigFromProps(props));
    const userTipoRef = useRef(userTipo); // Crea un ref per tenere sempre aggiornato il valore
    const pipSessionRef = useRef(createPictureInPictureSession());
    const pipSessionWindyRef = useRef(createPictureInPictureSession());
    const deviceOnlineStatus = useDeviceOnlineStatus(props.htkBackend, listSns, {
        enabled: isUserAccessResolved,
    });
    const apiClient = useMemo(
        () => createQcenterApiClient(props.htkBackend),
        [props.htkBackend]
    );

    useEffect(() => {
        ensureQcenterCsrfCookie(apiClient);
    }, [apiClient]);

    useEffect(() => subscribeSessionActive(setSessionActiveState), []);

    useEffect(() => subscribeAccountChange(() => {
        exitPictureInPictureIfActive();
        setListSns([]);
        setSnsLive([]);
        setSerialsAttivi([]);
        setFlyObjects([]);
        setButtonStates({});
        setInfoboxStates({});
        setInfoboxStatesPhoto({});
        setInfoboxStatesPolygon({});
        setInfoboxStatesStreaming({});
        setInfoboxStatesWindy({});
        setInfoboxStatesWindySimu({});
        setInfoboxStatesSimu({});
        setInfoboxStatesPhotoWindy({});
        setInfoboxStatesStreamingWindy({});
        setCurrentIconTypeStates({});
        setSessioniFromChild([]);
        setStartIndex(0);
        streamingConfigStartedRef.current = false;
        if (props.loadStreamingFromApi) {
            setStreamingConfig(createStreamingConfigFromProps(props));
        }
        setAccountEpoch(getSessionEpoch());
    }), [props.loadStreamingFromApi, props.htkBackend]);

    useEffect(() => {
        if (!sessionActive || props.accessMode) {
            return undefined;
        }

        const pageRoute = 'https://qlive.hightek.it';
        const stopPresence = startSessionPresence({
            apiClient,
            pageRoute,
            qliveUrl: pageRoute,
            workerUrl: `${process.env.PUBLIC_URL || ''}/sessionHeartbeatWorker.js`,
            intervalMs: HEARTBEAT_INTERVAL_MS,
        });
        const stopLiveCookie = startLiveStreamCookieRefresh(apiClient);

        return () => {
            if (typeof stopPresence === 'function') {
                stopPresence();
            }
            if (typeof stopLiveCookie === 'function') {
                stopLiveCookie();
            }
        };
    }, [apiClient, sessionActive, props.accessMode]);

    const [mappa, setMap] = useState(null);

    const breakpointRules = getBreakpointRules(window.innerWidth);

    const breakpointRulesResponsive = getBreakpointRulesResponsive(window.innerWidth);

    // stati bottoni infobox
    const [infoboxStates, setInfoboxStates] = useState({});
    const [infoboxStatesPhoto, setInfoboxStatesPhoto] = useState({});
    const [infoboxStatesPolygon, setInfoboxStatesPolygon] = useState({});
    const [infoboxStatesStreaming, setInfoboxStatesStreaming] = useState({});

    // stati bottoni infobox windy
    const [infoboxStatesWindy, setInfoboxStatesWindy] = useState({});
    const [infoboxStatesWindySimu, setInfoboxStatesWindySimu] = useState({});

    const [infoboxStatesSimu, setInfoboxStatesSimu] = useState({});
    const [infoboxStatesPhotoWindy, setInfoboxStatesPhotoWindy] = useState({});
    const [infoboxStatesStreamingWindy, setInfoboxStatesStreamingWindy] = useState({});

    const [sessioniFromChild, setSessioniFromChild] = useState([]);

    const [currentIconTypeStates, setCurrentIconTypeStates] = useState({});

    const handleIconTypeChange = (serialNumber, iconType) => {
        setCurrentIconTypeStates(prevStates => ({
            ...prevStates,
            [serialNumber]: iconType
        }));
    };

    // Aggiorna il ref ogni volta che userTipo cambia
    useEffect(() => {
        userTipoRef.current = userTipo;
    }, [userTipo]);
    
    useEffect(() => {

        //creazioneMappa();

        setTimeout(function() {
            //creazioneMappa2();
        }, 1500);
        
    }, []);


    // Funzione di callback per ricevere il valore aggiornato di sessioni dal componente figlio
    const handleSessioniChange = (newSessioni) => {
        setSessioniFromChild(newSessioni);
    };


    const fetchSerialAuth = async() => {
        if (!isSessionActive()) {
            return;
        }

        const epoch = getSessionEpoch();
        apiClient.get("/datalive/listSns")
            .then((response) => {
                if (!isSessionActive() || getSessionEpoch() !== epoch) {
                    return;
                }
                if (response.status == 200) {
                    let lstSNS = [];
                    if ( typeof response.data.serials == "undefined") {
                        lstSNS = [];
                    } else {
                        lstSNS = response.data.serials;
                    }

                    const nextSnKey = lstSNS.map((device) => device.sn).filter(Boolean).join('|');
                    setListSns((prevList) => {
                        const prevSnKey = prevList.map((device) => device.sn).filter(Boolean).join('|');
                        if (prevSnKey === nextSnKey) {
                            return prevList;
                        }
                        return lstSNS;
                    });
                }
            })
    }

    const fetchStreamingConfig = () => {
        if (!isSessionActive() || !props.loadStreamingFromApi) {
            return;
        }

        const epoch = getSessionEpoch();
        apiClient.get('/datalive/streamingConfig')
            .then((response) => {
                if (!isSessionActive() || getSessionEpoch() !== epoch) {
                    streamingConfigStartedRef.current = false;
                    return;
                }
                if (response.status === 200) {
                    setStreamingConfig(normalizeStreamingConfig(response.data));
                }
            })
            .catch((error) => {
                if (!isSessionActive() || getSessionEpoch() !== epoch) {
                    streamingConfigStartedRef.current = false;
                }
                console.warn('Configurazione streaming non disponibile da QCenter', error);
            });
    };

    
    const fetchSerials = async(...listSns) => {
        if (!isSessionActive()) {
            return;
        }

        const epoch = getSessionEpoch();

        const fetchSerial = async(sns) => {
                let baseUrl = props.htkCDN + "/" + sns.sn + "/history.json?"+Math.random();
                const url = new URL(baseUrl);
                //const chkHistory = checkHistory(url.href);
                //console.log("chkHistory:",chkHistory);
      //          if ( chkHistory) {

                    const res = await fetch(url.href);
                    const data = hydrateHistoryPayload(await res.json());


                    //console.log("RES: ", res);

                    let  newDataWithDirection = [];
                    if ( data.points.length >= 1) {
                        newDataWithDirection = data.points.map((p, i, a) => {
                            if ( i > 0) {
                                let p1 = {lat: a[i-1].point.points.LATITUDE ?? a[i-1].point.points.LAT, lng:a[i-1].point.points.LONGITUDE ?? a[i-1].point.points.LON };
                                let p2 = {lat: p.point.points.LATITUDE ?? p.point.points.LAT, lng:p.point.points.LONGITUDE ?? p.point.points.LON };

                                return {
                                    ...p,
                                    Direction: directionFunction(p1, p2),
                                    SN: sns.sn,
                                    ALIAS : sns.alias
                                }
                            } else {
                                return {...p,
                                    Direction: 0,
                                    SN: sns.sn,
                                    ALIAS : sns.alias}
                            }
                        })
                    }
                    const {dataSns: dataListSns} = newDataWithDirection
                    return newDataWithDirection;
            /*    } else {
                    console.log("NOT EXIST");
                }
            
            */
        };

        try {
            const promises = [];

            let elencoSerialiAutorizzati = listSns.filter(e => {
                return serialsAttivi.some(item => item.sn ===e.sn);
            });

            elencoSerialiAutorizzati.push()

            elencoSerialiAutorizzati.map( (singleSns) => {
                promises.push(fetchSerial(singleSns));
            });

            const snsLists = await Promise.all(promises);

            const openSn = new Set(snsLiveRef.current.map((device) => device.sn));
            const stillOpen = elencoSerialiAutorizzati
                .map((sns, index) => ({ sns, data: snsLists[index] }))
                .filter(({ sns }) => openSn.has(sns.sn))
                .map(({ data }) => data);

            if (!isSessionActive() || getSessionEpoch() !== epoch) {
                return;
            }

            setFlyObjects(stillOpen);

        } catch (err) {
            console.log("Errore:", err);
        }

    };

    const applyFlyObjectClose = (deviceSN) => {
        const nextFlyObjects = FlyObjects.filter((data) => data[0]?.SN !== deviceSN);
        const nextLength = nextFlyObjects.length;
        const rules = isMob
            ? getBreakpointRulesResponsive(window.innerWidth, nextLength)
            : getBreakpointRules(window.innerWidth, nextLength);

        setFlyObjects(nextFlyObjects);
        setStartIndex((prevStartIndex) => normalizeStartIndex(prevStartIndex, nextLength, rules));
    };

    const setFlyObject = (FO, stateButton, alias) => {
        if (stateButton) {
            applyFlyObjectClose(FO.sn);
        }

        setSnsLive(prevList => {
            const newList = stateButton
                ? prevList.filter((value) => value.sn !== FO.sn)
                : [...prevList.filter((value) => value.sn !== FO.sn), FO];

            // Aggiorniamo gli stati dei bottoni
            if (stateButton) {
                toggleFollowFalse(alias, stateButton);
                togglePhotoTrue(alias, stateButton);
                togglePolygonTrue(alias, stateButton);
            } else {
                toggleFollowFalse(alias, stateButton);
                togglePhotoFalse(alias, stateButton);
                togglePolygonFalse(alias, stateButton);
                toggleStreamingFalse(alias, stateButton);
            }

            return newList;
        });
    };

    const closeDeviceInfobox = async (deviceSN) => {
        const device = listSns.find((item) => item.sn === deviceSN);
        if (!device) {
            return;
        }

        await exitPictureInPictureIfActive();
        setFlyObject(device, true, device.alias);
        setButtonStates((prev) => ({
            ...prev,
            [device.sn]: false,
        }));
    };
    

    const listaSnsAttivi = (serialsAttivi) => {
        setSerialsAttivi(serialsAttivi);
    }

    const _userTipo = (tipo) => {
        setUserTipo(tipo);
    }

    useEffect(() => {
        if (props.accessMode) {
            setIsUserAccessResolved(true);
            return;
        }

        apiClient.get('/testing/json/user')
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error('user session not found');
                }

                if (isUserDisabled(response.data)) {
                    redirectDisabledUser(props.htkBackend);
                    return;
                }

                setIsUserAccessResolved(true);
            })
            .catch(() => {
                setIsUserAccessResolved(true);
            });
    }, [props.accessMode, props.htkBackend]);

    useEffect(() => {
        if (!props.loadStreamingFromApi) {
            setStreamingConfig(createStreamingConfigFromProps(props));
        }
    }, [props.loadStreamingFromApi, props.htkBackend]);

    useEffect(() => {
        if (!props.loadStreamingFromApi || !sessionActive || streamingConfigStartedRef.current) {
            return undefined;
        }

        streamingConfigStartedRef.current = true;
        fetchStreamingConfig();
    }, [props.loadStreamingFromApi, sessionActive, accountEpoch, props.htkBackend]);

    useEffect( () => {
        setTimePolling(1000);
    }, [snsLive])

    useEffect(() => {
        const intervalAuth = setInterval(() => {
            if (!isSessionActive()) {
                return;
            }
            fetchSerialAuth();
        }, 2000);

        const intervalSerials = setInterval(() => {
            if (!isSessionActive()) {
                return;
            }
            fetchSerials(...snsLive);
        }, timePolling);

        const stopSessionWatch = subscribeSessionActive((active) => {
            if (!active) {
                return;
            }
            fetchSerialAuth();
            fetchSerials(...snsLive);
        });

        return () => {
            clearInterval(intervalAuth);
            clearInterval(intervalSerials);
            stopSessionWatch();
        };
    }, [timePolling, snsLive]);


    const onLoginToggle = (newState) => {
        _logga("Login status changed to:", newState)
    }

    function _checkAccess() {
        setCode("1234");
        props.accessMode = true;
    }

    useEffect(() => {
        if (!props.accessMode && codeStart) {
            _checkAccess();
        }
    })

// questo effetto si assicura che lo stato infoboxStates sia aggiornato in modo che ogni alias presente in listSns abbia un corrispondente valore booleano in infoboxStates, impostato su false se non esiste ancora
      
// effetti bottoni infobox
    useEffect(() => {    
          const updatedStates = { ...infoboxStates };
          listSns.forEach((sn) => {
            if (!(sn.alias in updatedStates)) {
              updatedStates[sn?.alias] = false; 
            }
          });
          setInfoboxStates(updatedStates);
      }, [listSns]);

      useEffect(() => {    
          const updatedStates = { ...infoboxStatesSimu };
          listSns.forEach((sn) => {
            if (!(sn.alias in updatedStates)) {
              updatedStates[sn?.alias] = false; 
            }
          });
          setInfoboxStatesSimu(updatedStates);
      }, [listSns]);

      useEffect(() => {
        const updatedStates = { ...infoboxStatesPhoto };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesPhoto(updatedStates);
    }, [listSns]);

    useEffect(() => {
        const updatedStates = { ...infoboxStatesPolygon };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesPolygon(updatedStates);
    }, [listSns]);

    useEffect(() => {
        const updatedStates = { ...infoboxStatesStreaming };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesStreaming(updatedStates);

        //console.log("Infobox States Streaming " + JSON.stringify(infoboxStatesStreaming));

    }, [listSns]);

    //console.log("Infobox States Streaming " + JSON.stringify(infoboxStatesStreaming));

// effetti bottoni infobox windy
    useEffect(() => {    
        const updatedStates = { ...infoboxStatesWindy };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesWindy(updatedStates);
    }, [listSns]);

    useEffect(() => {    
        const updatedStates = { ...infoboxStatesWindySimu };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesWindySimu(updatedStates);
    }, [listSns]);

    useEffect(() => {
      const updatedStates = { ...infoboxStatesPhotoWindy };
      listSns.forEach((sn) => {
        if (!(sn.alias in updatedStates)) {
          updatedStates[sn?.alias] = false; 
        }
      });
      setInfoboxStatesPhotoWindy(updatedStates);
  }, [listSns]);

  useEffect(() => {
      const updatedStates = { ...infoboxStatesStreamingWindy };
      listSns.forEach((sn) => {
        if (!(sn.alias in updatedStates)) {
          updatedStates[sn?.alias] = false; 
        }
      });
      setInfoboxStatesStreamingWindy(updatedStates);
  }, [listSns]);


    const changeClick = () => {
        if(mappa){ 
            if(mappa.dragging){
                mappa.dragging.disable();
            }
            if(mappa.scrollWheelZoom){
                mappa.scrollWheelZoom.disable();
            }
        }
    }
    
    const changeClick2 = () => {
        if(mappa){
            if(mappa.dragging){
                mappa.dragging.enable();
            }
            if(mappa.scrollWheelZoom){
                mappa.scrollWheelZoom.enable();
            }
        }
    }

    // GESTIONE CLICK BOTTONI INFOBOX

    const toggleFollow = (nomeSeriale) => {
        setInfoboxStates((prevState) => {
            const isCurrentlyActive = !!prevState[nomeSeriale];

            if (isCurrentlyActive) {
                return {
                    ...prevState,
                    [nomeSeriale]: false,
                };
            }

            const newState = { ...prevState };
            Object.keys(newState).forEach((key) => {
                newState[key] = key === nomeSeriale;
            });
            newState[nomeSeriale] = true;

            return newState;
        });
      };

      const togglePhoto = (nomeSeriale) => {
        setInfoboxStatesPhoto((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const togglePolygon = (nomeSeriale) => {
        setInfoboxStatesPolygon((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const toggleStreaming = (nomeSeriale) => {
        setInfoboxStatesStreaming((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const releaseStreamingForAlias = (nomeSeriale) => {
        setInfoboxStatesStreaming((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const handlePictureInPictureEnter = (alias) => {
        pipSessionRef.current.handleEnter(alias, releaseStreamingForAlias);
      };

      const handlePictureInPictureLeave = (alias) => {
        pipSessionRef.current.handleLeave(alias);
      };

      const toggleFollowTrue = (nomeSeriale, stateButton) => {
        if (infoboxStates[nomeSeriale]) {
            setInfoboxStates((prevState) => ({
            ...prevState,
            [nomeSeriale]: true,
            }));
        }
      };

      const togglePhotoTrue = (nomeSeriale, stateButton) => {
        if (infoboxStatesPhoto[nomeSeriale]) {
            setInfoboxStatesPhoto((prevState) => ({
            ...prevState,
            [nomeSeriale]: true,
            }));
        }
      };

      const togglePolygonTrue = (nomeSeriale, stateButton) => {
        if (infoboxStatesPolygon[nomeSeriale]) {
            setInfoboxStatesPolygon((prevState) => ({
            ...prevState,
            [nomeSeriale]: true,
            }));
        }
      };

      const toggleFollowFalse = (nomeSeriale, stateButton) => {
        setInfoboxStates((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const togglePhotoFalse = (nomeSeriale, stateButton) => {
        setInfoboxStatesPhoto((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const togglePolygonFalse = (nomeSeriale, stateButton) => {
        setInfoboxStatesPolygon((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const toggleStreamingFalse = (nomeSeriale, stateButton) => {
        setInfoboxStatesStreaming((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

// GESTIONE CLICK BOTTONI INFOBOX WINDY

  const toggleFollowWindy = (nomeSeriale) => {
    setInfoboxStatesWindy((prevState) => {
      const newState = {
        ...prevState,
        [nomeSeriale]: !prevState[nomeSeriale],
      };
      // Disattiva tutti gli altri quando questo viene attivato
      if (newState[nomeSeriale]) {
        Object.keys(newState).forEach((key) => {
          if (key !== nomeSeriale) {
            newState[key] = false;
          }
        });
        // Disattiva anche l'altro stato (Simu) per questo seriale
        setInfoboxStatesWindySimu((prevSimuState) => ({
          ...prevSimuState,
          [nomeSeriale]: false,
        }));
      }
      return newState;
    });
  };
  
  const toggleFollowWindySimu = (nomeSeriale) => {
    setInfoboxStatesWindySimu((prevState) => {
      const newState = {
        ...prevState,
        [nomeSeriale]: !prevState[nomeSeriale],
      };
      // Disattiva tutti gli altri quando questo viene attivato
      if (newState[nomeSeriale]) {
        Object.keys(newState).forEach((key) => {
          if (key !== nomeSeriale) {
            newState[key] = false;
          }
        });
        // Disattiva anche l'altro stato (non Simu) per questo seriale
        setInfoboxStatesWindy((prevWindyState) => ({
          ...prevWindyState,
          [nomeSeriale]: false,
        }));
      }
      return newState;
    });
  };

  const togglePhotoWindy = (nomeSeriale) => {
    setInfoboxStatesPhotoWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: !prevState[nomeSeriale],
    }));
  };

  const toggleStreamingWindy = (nomeSeriale) => {
    setInfoboxStatesStreamingWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: !prevState[nomeSeriale],
    }));
  };

  const releaseStreamingForAliasWindy = (nomeSeriale) => {
    setInfoboxStatesStreamingWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: false,
    }));
  };

  const handlePictureInPictureEnterWindy = (alias) => {
    pipSessionWindyRef.current.handleEnter(alias, releaseStreamingForAliasWindy);
  };

  const handlePictureInPictureLeaveWindy = (alias) => {
    pipSessionWindyRef.current.handleLeave(alias);
  };

  const toggleFollowTrueWindy = (nomeSeriale, stateButton) => {
    if (infoboxStatesWindy[nomeSeriale]) {
        setInfoboxStatesWindy((prevState) => ({
        ...prevState,
        [nomeSeriale]: true,
        }));
    }
  };

  const toggleFollowTrueWindySimu = (nomeSeriale, stateButton) => {
    if (infoboxStatesWindySimu[nomeSeriale]) {
        setInfoboxStatesWindySimu((prevState) => ({
        ...prevState,
        [nomeSeriale]: true,
        }));
    }
  };

  const toggleFollowFalseWindy = (nomeSeriale) => {
    setInfoboxStatesWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: false,
    }));
  };
  
  const toggleFollowFalseWindySimu = (nomeSeriale, stateButton) => {
    setInfoboxStatesWindySimu((prevState) => ({
      ...prevState,
      [nomeSeriale]: false,
    }));
  };

  const openInfoboxAliases = useMemo(
    () => getOpenInfoboxAliases(snsLive),
    [snsLive]
  );

  const activeFollowAlias = useMemo(
    () => getActiveFollowAlias(infoboxStates, openInfoboxAliases),
    [infoboxStates, openInfoboxAliases]
  );

  useEffect(() => {
    setInfoboxStates((prevState) => cleanupFollowForClosedInfoboxes(prevState, openInfoboxAliases));
    setInfoboxStatesWindy((prevState) => cleanupFollowForClosedInfoboxes(prevState, openInfoboxAliases));
    setInfoboxStatesWindySimu((prevState) => cleanupFollowForClosedInfoboxes(prevState, openInfoboxAliases));
  }, [openInfoboxAliases]);


      const handleNext = () => {
        if (startIndex > 0) {
            setStartIndex((prevIndex) => prevIndex - 1);
          }
      };
    
      const handlePrev = () => {
        if (startIndex + 1 < FlyObjects.length) {
          setStartIndex((prevIndex) => prevIndex + 1);
        }
      };

    useLayoutEffect(() => {
        const rules = isMob
            ? getBreakpointRulesResponsive(window.innerWidth, FlyObjects.length)
            : getBreakpointRules(window.innerWidth, FlyObjects.length);

        setStartIndex((prevStartIndex) => normalizeStartIndex(
            prevStartIndex,
            FlyObjects.length,
            rules
        ));
    }, [FlyObjects.length, isMob]);

    function getBreakpointRulesResponsive(width, flyObjectsLength = FlyObjects.length) {

        // DA GESTIRE logica riguardo le diverse size da adattare tra i vari cellulari

        if(width >= 1 && width <= 374){
            return {
                startIndexCondition: flyObjectsLength - 1,
                flyObjectsCondition: flyObjectsLength >= 2,
            };
        }
        else if(width >= 375 && width <= 519){
            return {
                startIndexCondition: flyObjectsLength - 2,
                flyObjectsCondition: flyObjectsLength >= 3,
            };
        }
        else if(width >= 520 && width <= 664){
            return {
                startIndexCondition: flyObjectsLength - 3,
                flyObjectsCondition: flyObjectsLength >= 4,
            };
        }
        else if(width >= 665 && width <= 809){
            return {
                startIndexCondition: flyObjectsLength - 4,
                flyObjectsCondition: flyObjectsLength >= 5,
            };
        }
        else if(width >= 810 && width <= 954){
            return {
                startIndexCondition: flyObjectsLength - 5,
                flyObjectsCondition: flyObjectsLength >= 6,
            };
        }
        else if(width >= 955 && width <= 1099){
            return {
                startIndexCondition: flyObjectsLength - 6,
                flyObjectsCondition: flyObjectsLength >= 7,
            };
        }
        else if(width >= 1100 && width <= 1244){
            return {
                startIndexCondition: flyObjectsLength - 7,
                flyObjectsCondition: flyObjectsLength >= 8,
            };
        }
        else {
            return {
                startIndexCondition: flyObjectsLength - 7,
                flyObjectsCondition: flyObjectsLength >= 8,
            };
        }



    }

    function getBreakpointRules(width, flyObjectsLength = FlyObjects.length) {

        if (width >= 542 && width <= 935) {
            return {
                startIndexCondition: flyObjectsLength - 1,
                flyObjectsCondition: flyObjectsLength >= 2,
            };
        } else if (width > 935 && width <= 1328) {
            return {
                startIndexCondition: flyObjectsLength - 2,
                flyObjectsCondition: flyObjectsLength >= 3,
            };
        } else if (width > 1329 && width <= 1722) {
            return {
                startIndexCondition: flyObjectsLength - 3,
                flyObjectsCondition: flyObjectsLength >= 4,
            };
        } else if (width > 1722 && width <= 2115) {
            return {
                startIndexCondition: flyObjectsLength - 4,
                flyObjectsCondition: flyObjectsLength >= 5,
            };
        } else if (width > 2115 && width <= 2508) {
            return {
                startIndexCondition: flyObjectsLength - 5,
                flyObjectsCondition: flyObjectsLength >= 6,
            };
        } else {
            return {
                startIndexCondition: flyObjectsLength - 5,
                flyObjectsCondition: flyObjectsLength >= 6,
            };
        }
    }

        // Funzione per aggiornare la variabile mappaWindy
        const aggiornaMappaWindy = (nuovoValore) => {
            setMappaWindy(nuovoValore);
        };

        useEffect(() => {
            const handleResize = () => {
                // Invece di dispatchare un nuovo evento resize, aggiorniamo direttamente ciò che serve
                if (mappa) {
                    mappa.invalidateSize();
                }
                if (mappaWindy) {
                    mappaWindy.invalidateSize();
                }
            };
            

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, [mappa, mappaWindy]);

        const cambiaMappaLeaflet = () => {
            if (mappa) {
                mappa.invalidateSize();
            }
        };

        const cambiaMappaWindy = () => {
            if (mappaWindy) {
                mappaWindy.invalidateSize();
            }
        };

        const cambiaButton = (sn, nuovoStato) => {
/*
            console.log("LOG --->   sn : ", sn.sn);

            console.log("LOG --->   nuovoStato : ", nuovoStato);
*/
            // Aggiorna lo stato dei bottoni in base all'ID o ad un identificativo unico (sn)
            setButtonStates((prevStates) => ({
            ...prevStates,
            [sn.sn]: nuovoStato,
            }));

        };


        useEffect(() => {
            // Aggiungi questa riga per stampare l'array buttonStates
            //console.log("LOG --->   Stato attuale dei bottoni:", buttonStates);
            setButtonStates(buttonStates)
        }, [buttonStates]);

        
          const setFlyToGoogle3D = (lat, lng, altitude, heading) => {
           //console.log("MAPPA 3D : setFlyToGoogle3D");
            const mappaEarth = document.querySelector('gmp-map-3d');
            if(mappaEarth){
                // cambia la visuale della mappa 3D
                //console.log("cambia la visuale della mappa 3D");
                mappaEarth.center = { lat, lng, altitude };
                //mappaEarth.range = 400;
                //mappaEarth.tilt = 70;
                mappaEarth.heading = heading3D;
            }
            setHeading(heading);
          }

          const setFlyToGoogle3DFollow = (lat, lng, altitude, heading) => {
           //console.log("MAPPA 3D : setFlyToGoogle3DFollow");
            const mappaEarth = document.querySelector('gmp-map-3d');
            if(mappaEarth){
                // cambia la visuale della mappa 3D
                //console.log("cambia la visuale della mappa 3D");
                mappaEarth.center = { lat, lng, altitude };
                mappaEarth.range = 1000;
                mappaEarth.tilt = 70;
                mappaEarth.heading = 0;
            }
          }

          const setFlyToLeaflet = (lat, lon) => {
           //console.log("MAPPA LEAFLET : setFlyToLeaflet");
            if(mappa){
                mappa.panTo([lat, lon], flyZoomOptions);
            }
          }

        //console.log("è mobile? " + isMob + " ,  schermo di : " + windowWidthInit);

        if (!isUserAccessResolved) {
            return null;
        }

        _logga("user is loggedIn")
        return (<div className="map-wrapper">
            {code ?
                (
                    <>
                    <MapContainer
                        id="mappaLeaflet" 
                        className="leaflet-container mappaGoogle"
                        whenCreated={setMap}
                        center={startPosition}
                        zoom={zoomLevelBase}
                        zoomControl={false}
                        scrollWheelZoom={true}
                        doubleClickZoom={false}
                        inertia={true}
                        zoomSnap={1}
                        zoomDelta={1}
                    >
                
                        <LayerGroup>
                 
                                    <AuthController
                                        apibase={props.htkBackend}
                                        assetsBase={props.htkAssets}
                                        htkBackend = {props.htkBackend}
                                        onLoginToggle={onLoginToggle}
                                        accessMode={props.accessMode}
                                        _fnUserTipo={_userTipo}
                                        setMappaWindyProps={cambiaMappaWindy}
                                        setSerialsAttivi={listaSnsAttivi}
                                        listSns={listSns}
                                        userTipo={userTipo}
                                        onSessioniChange={handleSessioniChange}
                                    >

                                    </AuthController>

                            {
                                window.innerWidth > 1600 && 
                                    <ZoomControl position="bottomleft" />
                            } 
                            
                            <TileLayer
                                url='https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
                                subdomains={['mt1','mt2','mt3']}
                                />


                            {
                                FlyObjects.map((singleDataSn, index) => {
                                    const deviceSN = singleDataSn[0].SN;
                                    //console.log("singleDataSn [FLYOBJECT] : " , singleDataSn[0].SN);
                                    
                                    // Determina quale componente usare in base al tipo di dispositivo
                                    let ComponentToRender;
                                    if (streamingConfig.streamingDrone.includes(deviceSN)) {
                                        ComponentToRender = FlyObjectDrone;
                                    } else if (streamingConfig.streamingBarca.includes(deviceSN)) {
                                        ComponentToRender = FlyObjectBarca;
                                    } else {
                                        ComponentToRender = FlyObject;
                                    }

                                    return (
                                        <ComponentToRender 
                                            key={singleDataSn[singleDataSn.length-1].SN} 
                                            isMob={isMob}
                                            SN={deviceSN}
                                            ALIAS={singleDataSn[0].ALIAS}
                                            rilevazioni={singleDataSn}
                                            toggleFollow={toggleFollow}
                                            index={index}
                                            infoboxStates={infoboxStates}
                                            setInfoboxStates={setInfoboxStates}
                                            streamingDrone={streamingConfig.streamingDrone}
                                            streamingBarca={streamingConfig.streamingBarca}
                                            onIconTypeChange={handleIconTypeChange}
                                            userTipo={userTipo}
                                        />
                                    )
                                })
                            }

                            {
                                Array.isArray(sessioniFromChild) && sessioniFromChild.map((sessione, index) => {
                                    if (sessione.latitude !== null && sessione.longitude !== null && sessione.email !== null && sessione.id_utente !== null) {
                                        return (
                                            <UserObject
                                                key={index}
                                                sessione={sessione}
                                            />
                                        );
                                    }
                                    return null; // Ritorna null se la condizione non è soddisfatta
                                })
                            }

                            
                            {
                                !isMob && // per pc con dimensione dello schermo sopra i 919px
                                (
                                <div ref={shieldControlPanel} className="ControlPanelLaterale d-flex flex-column" id="controlPanelNuovo" 
                                onMouseOver={changeClick} 
                                onMouseOut={changeClick2} 
                                onMouseMove={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onMouseUp={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()} >
                                    <ControlPanel 
                                        userTipo={userTipo} 
                                        htkBackend={props.htkBackend} 
                                        setSerialsAttivi={listaSnsAttivi} 
                                        listSns={listSns} 
                                        setMainFlyObject={setFlyObject} 
                                        cambiaButton={cambiaButton}
                                        buttonStates={buttonStates}
                                        deviceOnlineStatus={deviceOnlineStatus}
                                    />
                                </div>
                                )
                            }


                            {
                                isMob && // mobile
                                (
                                <div ref={shieldMobileControlPanel} className="ControlPanelLateraleResponsive d-flex flex-column" id="controlPanelNuovoResponsive">
                                    <ControlPanelResponsive 
                                        userTipo={userTipo} 
                                        htkBackend={props.htkBackend} 
                                        setSerialsAttivi={listaSnsAttivi}
                                        listSns={listSns} 
                                        setMainFlyObject={setFlyObject}
                                    />
                                </div>
                                )
                            }

                            {
                                isMob && !isIOS &&         // sono su un dispositivo mobile NON IOS

                                <div ref={shieldMobileInfo} className='FlyInfoPanelContainerResp d-flex flex-center w-100'>
                                    <div className="FlyInfoPanelContainer2Resp">
                                        <div className="menuResp d-flex flex-center">

                                            <div className='d-flex flex-row divCenterResp'>

                                                <div className='buttonContainerResp d-flex flex-center'>
                                                    
                                                    {                               
                                                        !(startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition) && (
                                                        <button className="btn arrowButtonsResp d-flex flex-center" type="button">
                                                            <div
                                                                {...bindTap(
                                                                    startIndex !== breakpointRulesResponsive.startIndexCondition && breakpointRulesResponsive.flyObjectsCondition
                                                                        ? handlePrev
                                                                        : null
                                                                )}
                                                                className={`fas fa-chevron-left arrowIconsResp d-flex flex-center ${
                                                                    startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition
                                                                        ? 'disabled'
                                                                        : ''
                                                                }`}
                                                                alt="Indietro"
                                                            ></div>
                                                        </button>
                                                        )
                                                    }

                                                </div>

                                                <div className="items-containerResp">
                                                    
                                                    <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapperResp" style={{marginLeft: `${startIndex * 136}px`,transition: 'margin-left 0.3s ease-in-out',}}>
                                                        {
                                                            FlyObjects.map((singleDataSn, index) => {
                                                                const deviceSN = singleDataSn[0].SN;
                                                                return (<InfoBoxResponsiveNoIos
                                                                            key={singleDataSn[singleDataSn.length-1].SN}
                                                                            SN={deviceSN}
                                                                            ALIAS={singleDataSn[0].ALIAS}
                                                                            toggleFollow={toggleFollow}
                                                                            toggleFollowFalse={toggleFollowFalse}
                                                                            togglePhoto={togglePhoto}
                                                                            toggleStreaming={toggleStreaming}
                                                                            infoboxStates={infoboxStates}
                                                                            infoboxStatesPhoto={infoboxStatesPhoto}
                                                                            infoboxStatesStreaming={infoboxStatesStreaming}
                                                                            activeFollowAlias={activeFollowAlias}
                                                                            setInfoboxStates={setInfoboxStates}
                                                                            setInfoboxStatesStreaming={setInfoboxStatesStreaming}
                                                                            userTipo={userTipo}
                                                                            htkBackend={props.htkBackend}
                                                                            allData={singleDataSn}
                                                                            urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                                            urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                                            urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                                            urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                                            singleSnData={singleDataSn[singleDataSn.length-1]}
                                                                            serialiStreaming={streamingConfig.serialiStreaming}
                                                                            streamingH265={streamingConfig.streamingH265}
                                                                            streamingH264={streamingConfig.streamingH264}
                                                                            streamingDrone={streamingConfig.streamingDrone}
                                                                            streamingBarca={streamingConfig.streamingBarca}
                                                                            streamingSenzaSeqMission={streamingConfig.streamingSenzaSeqMission}
                                                                            setFlyToLeaflet={setFlyToLeaflet}
                                                                            currentIconType={currentIconTypeStates[deviceSN]}
                                                                        />)
                                                            })
                                                        }
                                                    </div>

                                                </div>

                                                <div className='buttonContainerResp d-flex flex-center'>

                                                        {
                                                            !(startIndex === 0) &&

                                                            <button className="btn arrowButtonsResp d-flex flex-center" type="button">
                                                                <div
                                                                    {...bindTap(startIndex !== 0 ? handleNext : null)}
                                                                    className={`fas fa-chevron-right arrowIconsResp d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                                                    alt="Avanti"
                                                                ></div>
                                                            </button>
                                                        }
                                                    
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                    
                                    
                            }


                            {
                                isMob && isIOS &&         // sono su un dispositivo mobile IOS

                                <div ref={shieldMobileInfoIos} className='FlyInfoPanelContainerResp d-flex flex-center w-100'>
                                    <div className="FlyInfoPanelContainer2Resp">
                                        <div className="menuResp d-flex flex-center">

                                            <div className='d-flex flex-row divCenterResp'>

                                                <div className='buttonContainerResp d-flex flex-center'>
                                                    
                                                    {                               
                                                        !(startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition) && (
                                                        <button className="btn arrowButtonsResp d-flex flex-center" type="button">
                                                            <div
                                                                {...bindTap(
                                                                    startIndex !== breakpointRulesResponsive.startIndexCondition && breakpointRulesResponsive.flyObjectsCondition
                                                                        ? handlePrev
                                                                        : null
                                                                )}
                                                                className={`fas fa-chevron-left arrowIconsResp d-flex flex-center ${
                                                                    startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition
                                                                        ? 'disabled'
                                                                        : ''
                                                                }`}
                                                                alt="Indietro"
                                                            ></div>
                                                        </button>
                                                        )
                                                    }

                                                </div>

                                                <div className="items-containerResp">
                                                    
                                                    <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapperResp" style={{marginLeft: `${startIndex * 136}px`,transition: 'margin-left 0.3s ease-in-out',}}>
                                                        {
                                                            FlyObjects.map((singleDataSn, index) => {
                                                                const deviceSN = singleDataSn[0].SN;
                                                                return (<InfoBoxResponsiveIos
                                                                            key={singleDataSn[singleDataSn.length-1].SN}
                                                                            SN={deviceSN}
                                                                            ALIAS={singleDataSn[0].ALIAS}
                                                                            toggleFollow={toggleFollow}
                                                                            toggleFollowFalse={toggleFollowFalse}
                                                                            togglePhoto={togglePhoto}
                                                                            toggleStreaming={toggleStreaming}
                                                                            infoboxStates={infoboxStates}
                                                                            infoboxStatesPhoto={infoboxStatesPhoto}
                                                                            infoboxStatesStreaming={infoboxStatesStreaming}
                                                                            activeFollowAlias={activeFollowAlias}
                                                                            setInfoboxStates={setInfoboxStates}
                                                                            setInfoboxStatesStreaming={setInfoboxStatesStreaming}
                                                                            userTipo={userTipo}
                                                                            htkBackend={props.htkBackend}
                                                                            allData={singleDataSn}
                                                                            urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                                            urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                                            urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                                            urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                                            singleSnData={singleDataSn[singleDataSn.length-1]}
                                                                            serialiStreaming={streamingConfig.serialiStreaming}
                                                                            streamingH265={streamingConfig.streamingH265}
                                                                            streamingH264={streamingConfig.streamingH264}
                                                                            streamingDrone={streamingConfig.streamingDrone}
                                                                            streamingBarca={streamingConfig.streamingBarca}
                                                                            streamingSenzaSeqMission={streamingConfig.streamingSenzaSeqMission}
                                                                            setFlyToLeaflet={setFlyToLeaflet}
                                                                            currentIconType={currentIconTypeStates[deviceSN]}
                                                                        />)
                                                            })
                                                        }
                                                    </div>

                                                </div>

                                                <div className='buttonContainerResp d-flex flex-center'>

                                                        {
                                                            !(startIndex === 0) &&

                                                            <button className="btn arrowButtonsResp d-flex flex-center" type="button">
                                                                <div
                                                                    {...bindTap(startIndex !== 0 ? handleNext : null)}
                                                                    className={`fas fa-chevron-right arrowIconsResp d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                                                    alt="Avanti"
                                                                ></div>
                                                            </button>
                                                        }
                                                    
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                    
                                    
                            }


                            { 
                                !isMob &&
                                
                                <div ref={shieldInfoPanels} className='FlyInfoPanelContainer d-flex flex-center w-100'>

                                    <div className="FlyInfoPanelContainer2">

                                        <div className="menu">

                                            <div className='buttonContainer d-flex flex-center'>
                                                
                                                
                                                {                               
                                                    !(startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition) && (
                                                    <button className="btn arrowButtons d-flex flex-center" type="submit">
                                                        <div
                                                            onClick={
                                                                startIndex !== breakpointRules.startIndexCondition && breakpointRules.flyObjectsCondition
                                                                    ? handlePrev
                                                                    : null
                                                            }
                                                            className={`fas fa-chevron-left arrowIcons d-flex flex-center ${
                                                                startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition
                                                                    ? 'disabled'
                                                                    : ''
                                                            }`}
                                                            alt="Indietro"
                                                        ></div>
                                                    </button>
                                                    )
                                                }

                                            </div>


                                            <div className="items-container">
                                                
                                                    <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapper" style={{ transform: `translateX(+${startIndex * 350}px)` }}>
                                                        {
                                                            FlyObjects.map((singleDataSn, index) => {
                                                                const deviceSN = singleDataSn[0].SN;
                                                                return snsLive.some(item => item.sn === deviceSN) ? (
                                                                    <InfoBox
                                                                        key={deviceSN}
                                                                        SN={deviceSN}
                                                                        ALIAS={singleDataSn[0].ALIAS}
                                                                        toggleFollow={toggleFollow}
                                                                        toggleFollowFalse={toggleFollowFalse}
                                                                        togglePolygonFalse={togglePolygonFalse}
                                                                        togglePhoto={togglePhoto}
                                                                        toggleStreaming={toggleStreaming}
                                                                        infoboxStates={infoboxStates}
                                                                        infoboxStatesPhoto={infoboxStatesPhoto}
                                                                        infoboxStatesPolygon={infoboxStatesPolygon}
                                                                        infoboxStatesStreaming={infoboxStatesStreaming}
                                                                        activeFollowAlias={activeFollowAlias}
                                                                        setInfoboxStatesPhoto={setInfoboxStatesPhoto}
                                                                        setInfoboxStatesPolygon={setInfoboxStatesPolygon}
                                                                        setInfoboxStates={setInfoboxStates}
                                                                        setInfoboxStatesStreaming={setInfoboxStatesStreaming}
                                                                        onPictureInPictureEnter={handlePictureInPictureEnter}
                                                                        onPictureInPictureLeave={handlePictureInPictureLeave}
                                                                        releaseStreaming={releaseStreamingForAlias}
                                                                        isDeviceOnline={deviceOnlineStatus[deviceSN] === true}
                                                                        onCloseInfobox={() => closeDeviceInfobox(deviceSN)}
                                                                        index={index}
                                                                        userTipo={userTipo}
                                                                        htkBackend={props.htkBackend}
                                                                        allData={singleDataSn}
                                                                        urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                                        urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                                        urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                                        urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                                        singleSnData={singleDataSn[singleDataSn.length-1]}
                                                                        serialiStreaming={streamingConfig.serialiStreaming}
                                                                        streamingH265={streamingConfig.streamingH265}
                                                                        streamingH264={streamingConfig.streamingH264}
                                                                        streamingDrone={streamingConfig.streamingDrone}
                                                                        streamingBarca={streamingConfig.streamingBarca}
                                                                        streamingSenzaSeqMission={streamingConfig.streamingSenzaSeqMission}
                                                                        setFlyToLeaflet={setFlyToLeaflet}
                                                                        currentIconType={currentIconTypeStates[singleDataSn[0].SN]}
                                                                    />
                                                                ) : null;
                                                            })
                                                        }
                                                    </div>

                                            </div>

                                            <div className='buttonContainer d-flex flex-center'>

                                               

                                                {
                                                    !(startIndex === 0) &&

                                                    <button className="btn arrowButtons d-flex flex-center" type="submit">
                                                        <div
                                                            onClick={startIndex !== 0 ? handleNext : null}
                                                            className={`fas fa-chevron-right arrowIcons d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                                            alt="Avanti"
                                                        ></div>
                                                    </button>
                                                }
                                            
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            }

                        </LayerGroup>

                </MapContainer>

                {/* Nodo Target per il Portale degli Stream della Barca */}
                <div id="boat-stream-portal-root"></div>

                </>
                )
                :
                (<div className="container d-flex flex-column aligns-items-center justify-content-center p-2">
                    <h4>QLive Application</h4>
                    <div className="d-flex w-25 flex-column justify-content-center">

                        <input className="p-2" placeholder="Insert code" onChange={(e) => {setDaCode(e.target.value)}} />
                        <button className="btn m-3" onClick={_checkAccess}>Access with {dataCode} code</button>
                    </div>
                </div>)

            }

 {
    
    !isMob &&
    <div id="mappaGoogle3D">
        <Map3DComponent
          htkApiMaps={props.htkApiMaps}
          infoboxStates={infoboxStatesWindy}
          infoboxStatesSimu={infoboxStatesWindySimu}
        />
    </div>
    
 }

    {
        !isMob &&
        <div className="spinner-wrapper" id="spinnerWrapper">
            <div className="loading-spinner"></div>
            <span className="spinner-text">3D</span>
        </div>
    }

 {
    !isMob &&
            <AuthControllerWindy
                apibase={props.htkBackend}
                assetsBase={props.htkAssets}
                htkBackend = {props.htkBackend}
                onLoginToggle={onLoginToggle}
                htkBackendEmail={props.htkBackendEmail}
                accessMode={props.accessMode}
                _fnUserTipo={_userTipo}
                userTipo={userTipo}
                mappaLeaflet={mappa}
                setMappaLeafletProps={cambiaMappaLeaflet}
            >

            </AuthControllerWindy>
}
     
        {
            !isMob &&
            <div className="ControlPanelLaterale ControlPanelWindy d-flex flex-column" id="controlPanelNuovoWindy">
                <ControlPanelWindy 
                    userTipo={userTipo} 
                    htkBackend={props.htkBackend} 
                    setSerialsAttivi={listaSnsAttivi} 
                    serials={snsJson.serials} 
                    listSns={listSns} 
                    setMainFlyObject={setFlyObject} 
                    cambiaButton={cambiaButton}
                    buttonStates={buttonStates}
                    deviceOnlineStatus={deviceOnlineStatus}
                />
            </div>
        
        }


        {
            !isMob &&

            <div className='FlyInfoPanelContainer FlyInfoPanelContainerWindy d-flex flex-center w-100'>

                <div className="FlyInfoPanelContainer2">

                    <div className="menu">

                        <div className='buttonContainer d-flex flex-center'>
                            
                            
                            {                               
                                !(startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition) && (
                                <button className="btn arrowButtons d-flex flex-center" type="submit">
                                    <div
                                        onClick={
                                            startIndex !== breakpointRules.startIndexCondition && breakpointRules.flyObjectsCondition
                                                ? handlePrev
                                                : null
                                        }
                                        className={`fas fa-chevron-left arrowIcons d-flex flex-center ${
                                            startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition
                                                ? 'disabled'
                                                : ''
                                        }`}
                                        alt="Indietro"
                                    ></div>
                                </button>
                                )
                            }

                        </div>

                        <div className="items-container">
                            
                                <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapper" style={{ transform: `translateX(+${startIndex * 350}px)` }}>
                                    {
                                        FlyObjects.map((singleDataSn, index) => {
                                            const deviceSN = singleDataSn[0].SN;
                                            return snsLive.some(item => item.sn === deviceSN) ? (<InfoBoxWindy
                                                        key={singleDataSn[singleDataSn.length-1].SN}
                                                        SN={deviceSN}
                                                        ALIAS={singleDataSn[0].ALIAS}
                                                        toggleFollow={toggleFollowWindy}
                                                        toggleFollowSimu={toggleFollowWindySimu}
                                                        toggleFollowFalse={toggleFollowFalseWindy}
                                                        toggleFollowFalseSimu={toggleFollowFalseWindySimu}
                                                        toggleFollowTrue={toggleFollowTrueWindy}
                                                        toggleFollowTrueSimu={toggleFollowTrueWindySimu}
                                                        togglePhoto={togglePhotoWindy}
                                                        toggleStreaming={toggleStreamingWindy}
                                                        infoboxStates={infoboxStatesWindy}
                                                        infoboxStatesSimu={infoboxStatesWindySimu}
                                                        infoboxStatesPhoto={infoboxStatesPhotoWindy}
                                                        infoboxStatesStreaming={infoboxStatesStreamingWindy}
                                                        openInfoboxAliases={openInfoboxAliases}
                                                        setInfoboxStatesPhoto={setInfoboxStatesPhotoWindy}
                                                        setInfoboxStates={setInfoboxStatesWindy}
                                                        setInfoboxStatesSimu={setInfoboxStatesWindySimu}
                                                        setInfoboxStatesStreaming={setInfoboxStatesStreamingWindy}
                                                        onPictureInPictureEnter={handlePictureInPictureEnterWindy}
                                                        onPictureInPictureLeave={handlePictureInPictureLeaveWindy}
                                                        releaseStreaming={releaseStreamingForAliasWindy}
                                                        setFlyToGoogle3D={setFlyToGoogle3D}
                                                        setFlyToGoogle3DFollow={setFlyToGoogle3DFollow}
                                                        index={index}
                                                        userTipo={userTipo}
                                                        htkBackend={props.htkBackend}
                                                        htkCDN={props.htkCDN}
                                                        allData={singleDataSn}
                                                        urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                        urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                        urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                        urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                        singleSnData={singleDataSn[singleDataSn.length-1]}
                                                        allSnData={singleDataSn}
                                                        serialiStreaming={streamingConfig.serialiStreaming}
                                                        streamingH265={streamingConfig.streamingH265}
                                                        streamingH264={streamingConfig.streamingH264}
                                                        streamingDrone={streamingConfig.streamingDrone}
                                                        streamingBarca={streamingConfig.streamingBarca}
                                                        streamingSenzaSeqMission={streamingConfig.streamingSenzaSeqMission}
                                                        rilevazioni={singleDataSn}
                                                        currentIconType={currentIconTypeStates[deviceSN]}
                                                    />) : null
                                        })
                                    }
                                </div>

                        </div>

                        <div className='buttonContainer d-flex flex-center'>

                            

                            {
                                !(startIndex === 0) &&

                                <button className="btn arrowButtons d-flex flex-center" type="submit">
                                    <div
                                        onClick={startIndex !== 0 ? handleNext : null}
                                        className={`fas fa-chevron-right arrowIcons d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                        alt="Avanti"
                                    ></div>
                                </button>
                            }
                        
                        </div>

                    </div>

                </div>

            </div>


                        }


        </div>);
}
export default App;
